import axios from 'axios'
import { getBase } from '../utils/requests'

export const fetchMockupImage = async (designId, isPreview) => {
  return await axios.post(`${getBase()}/design/render-mockup`, { designId, isPreview })
}